import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { CONFIGURE_CATEGORIES_LIST } from "../../../Constants/Config";
import axios from "axios";
import { toThunkRejectValue } from "../../../Common/isRequestCanceled";
import { ciUrl } from "../../../Constants/nodeCi";

const initialState = {
  loading: true,
  configureCategoryList: [],
  //   tagData:[],
  successMessage: "",
  error: "",
};

export const fetchConfigureCategoryList = createAsyncThunk(
  "configureSlice/fetchConfigureCategoryList",
  async (data, { rejectWithValue }) => {
    // console.log(data);
    const { token, ...dataNew } = data;
    try {
      let response = await axios.post(
        ciUrl(CONFIGURE_CATEGORIES_LIST),
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.data?.status == true) {
        return response?.data?.cat_data;
      } else {
        return [];
      }
    } catch (e) {}
    // try {
    //   const response = await axios.post(
    //     BASE_URL + GET_BRAND_DATA_LIST,
    //     dataNew,
    //     {
    //       headers: {
    //         "Content-Type": "multipart/form-data",
    //         Authorization: `Bearer ${token}`,
    //       },
    //     }
    //   );
    //   if (response?.data?.status == true) {
    //     return response?.data?.data;
    //   }
    // } catch (error) {
    //   const customError = {
    //     message: error.message,
    //     status: toThunkRejectValue(error).status,
    //     data: error.response ? error.response.data : null,
    //   };
    //   return rejectWithValue(customError);
    // }
  }
);
const ConfigureCategoriesSlice = createSlice({
  name: "configureSlice",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchConfigureCategoryList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchConfigureCategoryList.fulfilled, (state, action) => {
      state.loading = false;
      state.configureCategoryList = action.payload;
      state.successMessage = "";
    });
    builder.addCase(fetchConfigureCategoryList.rejected, (state, action) => {
      state.loading = false;
      state.configureCategoryList = [];
      state.successMessage = action.error.message;
    });
  },
});

// export const { editAttribute } = attributesSlice.actions;
export default ConfigureCategoriesSlice.reducer;
